/* tslint:disable */

/**
 */
export class DeviceInput {
    style_search?: string;
    key_input?: string;
}
